<template>
    <ol class="fs-mask">
        <template v-for="(message, index) in rolePlayMessages" :key="message.chat_message_id">
            <li
                v-if="feedbackForMessage(message.chat_message_id)"
                :ref="(el) => refForLine(el, message.chat_message_id)"
                class="duration-500 transition-colors ease-in body flex gap-4 hover:bg-surface-hover hover:duration-150 rounded-xl p-2 m-2 mb-3"
                :class="focusedFeedback === message.chat_message_id ? 'bg-surface-sunken' : ''">
                <span>{{ index + 1 }}</span>
                <BaseButton
                    theme="tertiary"
                    :title="t('chat.widgets.rolePlay.viewMessage')"
                    class="whitespace-normal p-0 text-left nadia-chat text-ink-muted hover:bg-transparent"
                    @click="focusChatMessage(message.chat_message_id)">
                    {{ feedbackForMessage(message.chat_message_id) }}
                </BaseButton>
            </li>
        </template>
    </ol>
</template>

<script setup lang="ts">
import { type GlobalProperties } from "~vue/appTypes";
import { getRolePlayMonitorParams } from "~vue/chatActions";
import BaseButton from "~vue/components/BaseButton.vue";
import { CHAT_EVENT } from "~vue/events";
import type { ChatMessage } from "~vue/types/chat";
import { type ComponentPublicInstance, computed, inject } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const { emitter } = inject<GlobalProperties>("globalProperties", {} as GlobalProperties);

type ChatRolePlayFeedbackProps = {
    rolePlayMessages: ChatMessage[];
    refForLine: (el: Element | ComponentPublicInstance | null, messageId: number) => void;
    focusedFeedback: number | null;
};

const { rolePlayMessages, refForLine, focusedFeedback } = defineProps<ChatRolePlayFeedbackProps>();

const rolePlayMessageMonitorProps = computed(() =>
    rolePlayMessages.reduce<Record<number, ReturnType<typeof getRolePlayMonitorParams>>>((aggregator, current) => {
        const params = getRolePlayMonitorParams(current);
        return {
            ...aggregator,
            [current.chat_message_id]: params,
        };
    }, {}),
);

const feedbackForMessage = (messageId: number) => {
    const rolePlayMonitorProps = rolePlayMessageMonitorProps.value[messageId];
    return rolePlayMonitorProps && rolePlayMonitorProps.feedback ? rolePlayMonitorProps.feedback : null;
};

const focusChatMessage = (chatMessageId: number) => {
    emitter.emit(CHAT_EVENT.FOCUS_CHAT_MESSAGE, { chatMessageId });
};
</script>

<style scoped></style>
